import React from 'react';
import { Text, View, Dimensions, Image, Pressable } from 'react-native';
import { Button } from 'LocalGluons';
import { Device } from 'DeviceUtils';
import { useStore } from 'Store/Store';
import { t } from 'Locale';
import type { NativeConsentDefinition } from 'types';
import renderHTMLText from '../../../localGluons/components/RenderHtmlText/renderHtmlText';
import style from './NativeConsentsIntro.jss';

interface ConsentsResponse {
    consents: NativeConsentDefinition[];
    backgroundImageUrlPortrait: string;
    backgroundImageUrlLandscape: string;
}

interface ConsentsIntroPageProps {
    navigation: any;
    setModalContent: (newModalContent: any, hwBackHandler?: any) => void;
    consentsResponse: ConsentsResponse;
    setShowConsentsAgain: React.Dispatch<React.SetStateAction<boolean>>;
}

const ConsentsIntroPage = ({
    navigation,
    setModalContent,
    consentsResponse,
    setShowConsentsAgain
}: ConsentsIntroPageProps) => {
    const { consents } = consentsResponse;
    const { appManager } = useStore();
    const {
        backstageConnector: { auth }
    } = appManager.getApi();

    const windowWidth = Dimensions.get('window').width;
    const windowHeight = Dimensions.get('window').height;

    const handleCustomizeConsents = (): void => {
        navigation.navigate('NativeConsents', { setShowConsentsAgain });
        // there is delay between switching sreens
        setTimeout(() => setModalContent(null), 10);
    };

    const handleAcceptAll = async () => {
        try {
            const approvedConsents = consents.map((consent: NativeConsentDefinition) => ({
                name: consent.name,
                value: true
            }));
            await auth.postNativeConsents({ consents: approvedConsents });
            const loggedUserData = await appManager.getLoggedUserObjectDataFromStorage();
            await appManager.refreshToken(loggedUserData);
            setModalContent(null);
        } catch (error) {
            console.log(error);
        }
    };

    const description = {
        html: `<div style="textAlign:center">${t(
            'CONSENTS.MAIN_POPUP_DESCRIPTION_MOBILES'
        )}</div>`
    };
    return (
        <View style={style.container}>
            {Device.isPhone && (
                <View style={style.container}>
                    <Image
                        source={{ uri: consentsResponse.backgroundImageUrlPortrait }}
                        style={
                            (style.backgroundImage, [{ width: windowWidth, height: windowHeight }])
                        }
                    />
                    <View style={style.overlayMobile}>
                        <Text style={style.title}>{t('CONSENTS.MAIN_POPUP_TITLE_MOBILES')}</Text>
                        <View style={style.divider} />
                        {renderHTMLText(description, {}, { a: style.link })}
                        <Pressable
                            onPress={handleCustomizeConsents}
                            style={style.buttonDetailed}
                        >
                            <Text style={style.buttonText}>
                                {t('CONSENTS.MAIN_POPUP_BTN_SETTINGS_MOBILES')}
                            </Text>
                        </Pressable>

                        <Button
                            title={t('CONSENTS.MAIN_POPUP_BTN_OK_MOBILES')}
                            onPress={handleAcceptAll}
                        />
                    </View>
                </View>
            )}
            {Device.isTabletOrWeb && (
                <View style={Device.isTablet ? style.container : style.webContainer}>
                    {Device.isTablet && (
                        <Image
                            source={{ uri: consentsResponse.backgroundImageUrlLandscape }}
                            style={
                                (style.backgroundImage,
                                    [{ width: windowWidth, height: windowHeight }])
                            }
                        />
                    )}
                    <View style={Device.isTablet ? style.overlayTablet : style.overlayWeb}>
                        <Text style={style.title}>{t('CONSENTS.MAIN_POPUP_TITLE_MOBILES')}</Text>
                        <View style={style.divider} />
                        {renderHTMLText(description, {}, { a: style.link })}
                        <View style={style.alignmentsOnWeb}>
                            <Pressable
                                onPress={handleCustomizeConsents}
                                style={style.buttonDetailed}
                            >
                                <Text style={style.buttonText}>
                                    {t('CONSENTS.MAIN_POPUP_BTN_SETTINGS_MOBILES')}
                                </Text>
                            </Pressable>
                            <View style={style.buttonAcceptAll}>
                                <Button
                                    title={t('CONSENTS.MAIN_POPUP_BTN_OK_MOBILES')}
                                    onPress={handleAcceptAll}
                                />
                            </View>
                        </View>
                    </View>
                </View>
            )}
        </View>
    );
};

export default ConsentsIntroPage;
